<!-- <div class="online" [class.flash]="animate">
  <i class="circle"></i>
  <span>{{ value }}</span>
  <span>online</span>
</div> -->
<div class="online" [class.hidden]="value === 0">
  <i class="circle"></i>
  <span>{{ value }}</span>
  <span>online</span>
</div>
